<template>
  <div>
    <v-container class="my-7">
      <Banner v-if="sm" type="top" />

      <v-row class="mt-4">
        <v-col cols="12" class="mt-4 pr-lg-16">
          <Title class="mb-4">{{ content.title }}</Title>

          <div v-html="content.text"></div>
        </v-col>
      </v-row>
      <Banner type="center-2" class="mt-7" />
    </v-container>
  </div>
</template>

<script>
import Title from "@/components/widgets/Title.vue";
import Banner from "@/components/cards/Banner.vue";
import { getSocial, getContact } from "@/config.js";

export default {
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return getSocial(this);
    },
    contact() {
      return getContact(this);
    },
    content() {
      return this.$rest("about").item;
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  components: {
    Title,
    Banner,
  },
};
</script>
